var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_517_1424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8916 0.476562C4.47285 0.476562 0.891602 3.16094 0.891602 6.47656C0.891602 8.82031 2.68848 10.8453 5.30098 11.8328L3.55723 16.4766L8.57285 12.4641C8.6791 12.4672 8.78223 12.4766 8.8916 12.4766C13.3104 12.4766 16.8916 9.79219 16.8916 6.47656C16.8916 3.16094 13.3104 0.476562 8.8916 0.476562Z",
    fill: "#FD4319"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_517_1424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.891602 0.476562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBubble);
export default __webpack_public_path__ + "static/media/TextBubble.bd38d9625cd1a3e2bf4817a115004d0e.svg";
export { ForwardRef as ReactComponent };